module.exports = __webpack_public_path__ + "img/picture_26.641d34fb.png";